export default __webpack_public_path__ + "static/media/arrow-forward.8f29b9d9.svg";